import uiBootstrap from 'angular-ui-bootstrap';
import translate from 'angular-translate';

export default angular.module('eventix.common.services.ConfirmDeleteSweet', [uiBootstrap, translate])
/**
 * @ngdoc service
 * @name eventix.common.services.ConfirmDeleteSweet
 * @requires ui.bootstrap
 * @description
 * A global service for asking user confirmation before deleting
 *
 * @example
 * <pre>
 * vm.delete = function(item) {
 *     ConfirmDeleteSweet.open(item.name).then( function(){
 *         return item.$delete();
 *     });
 * }
 * </pre>
 */
    .service('ConfirmDeleteSweet', function (SweetAlert, $translate, $q) {
        /**
         * @ngdoc method
         * @name eventix.common.services.ConfirmDelete#open
         * @methodOf eventix.common.services.ConfirmDelete
         * @description
         * Open the confirmation dialog
         *
         * @param {String} identifier A name to identify the item which will be deleted
         * @param {Object} [translations] Optional object with translation overrides
         * Default value:
         * ```
         * {
         *     "title": "common.action.delete",
         *     "text": {
         *         "translation": "comomn.notice.deleteConfirm",
         *         "values": { "object": identifier.toString() }
         *     },
         *     "confirm": "common.action.delete",
         *     "cancel": "common.action.cancel"
         * }
         * ```
         * @param {Boolean} closeAfterConfirm Wheter or not the SweetAlert should close after a confirm.
         * @returns {Promise} Resolves if the user confirms deletion, rejects otherwise
         */
        this.open = function (identifier, translations = {}, closeAfterConfirm = true) {
            let translationValues = {
                object: _.isString(identifier) ? identifier : _.toString(identifier)
            };

            let t = _.defaultsDeep({}, translations, {
                title: 'common.notice.attention',
                text: {
                    translation: 'common.notice.deleteConfirm',
                    values: translationValues
                },
                confirm: 'common.action.delete',
                cancel: 'common.action.cancel',
                cancelled: 'common.notice.cancelled',
                cancelledText: 'common.notice.nothingWillBeDeleted',
                ok: 'common.action.ok'
            });

            if (_.isString(t.text))
                t.text = {translation: t.text};

            return $q((resolve, reject) => {
                SweetAlert.swal(
                    {
                        title: $translate.instant(t.title),
                        text: $translate.instant(t.text.translation, t.text.values),
                        type: 'warning',
                        confirmButtonColor: "#ff9600",
                        confirmButtonText: $translate.instant(t.confirm),
                        showCancelButton: true,
                        cancelButtonText: $translate.instant(t.cancel),
                        closeOnCancel: false,
                        closeOnConfirm: false
                    },
                    (isConfirm) => {
                        if (isConfirm) {
                            if (closeAfterConfirm)
                                SweetAlert.close();

                            resolve();
                        } else {
                            SweetAlert.swal({
                                title: $translate.instant(t.cancelled),
                                text: $translate.instant(t.cancelledText),
                                type: 'error',
                                comfirmButtonText: $translate.instant(t.ok),
                                closeOnClickOutside: true,
                                timer: 3000
                            });
                        }
                    }
                );
            });
        };
    }).name;
